'use client'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { Maybe } from '.'
import type { Props } from './product-card-gallery'
import AddToCartButton from '../add-to-cart-button'
import GoToProductButton from '../go-to-product-button/go-to-product-button'
import classNames from 'classnames'

type ToProductButtonProps = {
  show?: boolean
  productErpIdentifier: Props['product']['productErpIdentifier']
  nameSlug: Props['product']['nameSlug']
  product: Props['product']
  ticket: Props['ticket']
  addToCartText?: string
  mainProductErpIdentifier?: Maybe<Props['product']['manufacturerProductIdentifier']>
  quantity?: number
  digitalDataOrigin: Props['digitalDataOrigin']
  digitalIndex?: Props['digitalIndex']
  primary?: Props['primary']
  showFavoritesButtonBreakpoint?: boolean
  isProductAccessories?: Props['isProductAccessories']
  preventSetLastUpdatedProductErpIdentifier?: Props['preventSetLastUpdatedProductErpIdentifier']
  isMinSmallMobile?: boolean
  hideCartButton?: boolean
}
export default function ToProductButton({
  show,
  productErpIdentifier,
  nameSlug,
  product,
  ticket,
  addToCartText,
  mainProductErpIdentifier,
  quantity = 1,
  digitalDataOrigin,
  digitalIndex,
  primary,
  showFavoritesButtonBreakpoint,
  isProductAccessories,
  preventSetLastUpdatedProductErpIdentifier,
  isMinSmallMobile,
  hideCartButton = !isMinSmallMobile && !isProductAccessories,
}: ToProductButtonProps) {
  const { translate } = useTranslations()
  const fallbackShow = product?.minQuantityPerOrder && product.minQuantityPerOrder > 1

  if (show || fallbackShow) {
    return <GoToProductButton productErpIdentifier={productErpIdentifier} nameSlug={nameSlug} />
  }

  return (
    <AddToCartButton
      product={product}
      ticket={ticket}
      addToCartText={addToCartText || translate('AddToCart')}
      isAd={false}
      mainProductErpIdentifier={mainProductErpIdentifier ?? null}
      quantity={quantity}
      digitalDataOrigin={digitalDataOrigin}
      digitalDataIndex={digitalIndex}
      primary={primary}
      className={classNames('u-w-100', {
        'u-mr-8': showFavoritesButtonBreakpoint,
        'd-none': hideCartButton,
      })}
      preventSetLastUpdatedProductErpIdentifier={preventSetLastUpdatedProductErpIdentifier}
    />
  )
}
